<app-dialog-header [title]="'EVENT.ATTENDANCE.EVENT_ATTENDANCE'" (onClick)="dialogRef.close(null)"></app-dialog-header>

<div mat-dialog-content fxLayout="column" fxLayoutAlign="start" class="p-24 pt-8">
    <div class="attendance-panel">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="attendance-toolbar">
            <mat-form-field class="attendance-filter-field">
                <mat-label>{{ 'EVENT.ATTENDANCE.FILTER_BY_ATTENDANCE' | translate }}</mat-label>
                <mat-select [formControl]="attendanceStatusFilter">
                    <mat-option [value]="null">{{ 'EVENT.ATTENDANCE.STATUS.ALL' | translate }}</mat-option>
                    <mat-option *ngFor="let attendanceStatus of attendanceStatuses" [value]="attendanceStatus.value">
                        {{ attendanceStatus.translationLabel | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <app-search-outline [searchInput]="searchInput"></app-search-outline>
        </div>

        <app-module-event-attendance-list
            [eventId]="eventId"
            [filteredModuleEventAttendances$]="filteredModuleEventAttendances$"
            [moduleEventAttendancesStateSearchTerm$]="moduleEventAttendancesStateSearchTerm$"
            [selectedAttendanceStatus$]="selectedAttendanceStatus$"
        ></app-module-event-attendance-list>
    </div>
</div>
